let environment;

if (process.env.HOSTNAME?.indexOf('dev.') !== -1) {
  environment = 'dev';
} else if (process.env.HOSTNAME?.indexOf('staging.') !== -1) {
  environment = 'qa';
} else if (process.env.HOSTNAME?.indexOf('www.') !== -1) {
  environment = 'prod';
}

export const utagData = `var utag_data = {};`;

export const utagImport = `(function (a, b, c, d) {
  a = '//tags.tiqcdn.com/utag/gjensidige/gjensidige.builders/${environment}/utag.js';
  b = document; c = 'script'; d = b.createElement(c); d.src = a; d.type = 'text/java' + c; d.async = true;
  a = b.getElementsByTagName(c)[0]; a.parentNode.insertBefore(d, a);
})()`;

if (process.env.NODE_ENV === 'production') {
  const head = document.head;
  const newScript = document.createElement('script');

  const inlineData = document.createTextNode(utagData);
  const inlineScript = document.createTextNode(utagImport);

  newScript.appendChild(inlineData);
  newScript.appendChild(inlineScript);
  head.appendChild(newScript);
}
